export const DESCRIPTIVE_TABLE_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.DescriptiveTableWidgetElement';
